import React from 'react';
import Button from '@material-ui/core/Button';
interface Props {
  label?: string;
  onClick: () => void;
  disabled?: boolean;
}

export default function CancelButton({ label = 'Cancel', disabled = false, ...other }: Props) {
  return (
    <Button disabled={disabled} {...other}>
      {label}
    </Button>
  );
}
